import { useTranslation } from "react-i18next";
import ServiceCard from "./serviceCard";

const Services = () => {
  const { t } = useTranslation();

  const servicesType = [
    {
      image: "/assets/airTransportation.png",
      header: t("airTransportation"),
      description: t("airLineCargoService"),
      link: "/services/air-transportation",
    },
    {
      image: "/assets/landTransportation.jpg",
      header: t("landTransportation"),
      description: t("methodForTransporting"),
      link: "/services/land-transportation",
    },
    {
      image: "/assets/shipRental.png",
      header: t("shipRental"),
      description: t("airLineCargoService"),
      link: "/services/ship-rental",
    },
    {
      image: "/assets/dangerousTransportation.png",
      header: t("dangerousGoodsTransport"),
      description: t("processOfPacking"),
      link: "/services/dangerous-goods",
    },

    {
      image: "/assets/trainTransportation.jpg",
      header: t("shippingByTrains"),
      description: t("railFreight"),
      link: "/services/train-transportation",
    },
    {
      image: "/assets/CBM.png",
      header: t("partialTransport"),
      description: t("partialTransportWithCBM"),
      link: "/services/partial-transport",
    },

    {
      image: "/assets/caching.png",
      header: t("caching"),
      description: t("itCanDefined"),
      link: "/services/caching",
    },
    {
      image: "/assets/productLogistics.png",
      header: t("productionLogistics"),
      description: t("duringTheTransportationProcess"),
      link: "/services/production-logistics",
    },
    {
      image: "/assets/customerClearance.png",
      header: t("customClearance"),
      description: t("itCanDefined"),
      link: "/services/customs-clearance",
    },
  ];
  return (
    <article className=" py-20  bg-[#F9F8FE]">
      <div className="w-11/12 mx-auto">
        <h1 className="text-mainBlue font-semibold text-[32px] text-center pb-10">
          {t("logisticsServices")}
        </h1>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {servicesType.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              header={service.header}
              description={service.description}
              link={service.link}
            />
          ))}
        </div>
      </div>
    </article>
  );
};

export default Services;
